import { useMemo, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { actionWakeMode } from 'shared/lib'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SidebarV2 } from 'widgets/Sidebar/ui/SidebarV2'
import { SidebarContext, useSidebarContext } from 'widgets/Sidebar/context/sidebarContext'
import { SidebarStore } from 'widgets/Sidebar/store/sidebarStore'
import { useEventConversationUnread } from 'widgets/Sidebar/events/EventConversationUnread'

export const SidebarContent = observer(() => {
  const store = useSidebarContext()

  useEventConversationUnread(store)

  useEffect(() => {
    store.init()
    store.handleReactionInboxes()

    return () => {
      store.reset()
    }
  }, [])

  useEffect(() => {
    actionWakeMode(() => {
      store.reInitInboxes()
    })
  }, [])

  return <SidebarV2 />
})

export const Sidebar = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new SidebarStore(entities), [])

  return (
    <SidebarContext.Provider value={store}>
      <SidebarContent />
    </SidebarContext.Provider>
  )
}
